module.exports = __webpack_public_path__ + "img/vpc-icon.3a1eb28.webp";